<template>
  <div
    class="rounded-medium flex flex-col"
    :class="[
      type == 'elevated' && 'bg-surface-container-low shadow-1',
      type == 'filled' && 'bg-surface-container',
      type == 'outlined' && 'border-outline-variant bg-surface border',
    ]"
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
  interface Props {
    type?: 'elevated' | 'filled' | 'outlined'
  }

  const { type = 'filled' } = defineProps<Props>()
</script>
